@use "sass:color";
@use "styles/abstracts/variables" as v;
@use "styles/abstracts/mixins/typography" as t;

@keyframes rotateAnimation {
  0%, 100% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.cardStatus {
  border-radius: 10px;
  background-color: v.$palette-purple;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 10px;
  outline: none;
  appearance: none;
  cursor: pointer;
  border: none;
  z-index: 1;
  transition: background-color v.$transition-duration ease-in-out;

  &::-moz-focus-inner {
    border: 0;
  }

  &:hover {
    background-color: color.adjust($color: v.$palette-purple-raw, $lightness: 5%);
  }

  .text {
    text-transform: uppercase;
    text-align: center;
    color: v.$palette-pure-white;
    @include t.text(10px, 14px, 600);
  }

  .icon {
    margin-left: 5px;

    path {
      fill: v.$palette-pure-white;
    }
  }

  &.isUpdating {
    .icon {
      animation: rotateAnimation 1.7s linear infinite;
    }
  }
}
